import input from './input.vue'
import checkbox from './checkbox.vue'
import region from './region.vue'
import member from './member.vue'
import department from './department.vue'
import cascadeSelect from './cascadeSelect.vue'
import statistics from './statistics.vue'
import disableText from './disableText.vue'
export default {
  text: input,
  phone: input,
  email: input,
  number: statistics,
  checkbox,
  radio: checkbox,
  region,
  member,
  department,
  associationField: input,
  cascadeSelect,
  statistics,
  disableText,
  stepBar: checkbox,
}
